module.exports = '<svg width="37" height="32" viewBox="0 0 37 32"><path d="M34.286 25.143V2.286A2.284 2.284 0 0 0 32 0H4.571a2.284 2.284 0 0 0-2.286 2.286v22.857a2.284 2.284 0 0 0-2.286 2.286v2.286a2.284 2.284 0 0 0 2.286 2.286h32a2.284 2.284 0 0 0 2.286-2.286v-2.286a2.284 2.284 0 0 0-2.286-2.286zM6.857 4.571h22.857v16H6.857v-16zm16 22.858h-9.143v-2.286h9.143v2.286z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/macbook-1.js
// module id = 1246
// module chunks = 14